<button class="flex justify-center items-center gap-2" (click)="onBack()">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="font-normal text-muted dark:text-white"
  >
    <path
      d="M15 18L9 12L15 6"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <h5 class="font-medium text-lg text-muted dark:text-white">
    {{ "Shared.Back" | translate }}
  </h5>
</button>
